import React from 'react';
import { Target, KeySquare, Palette, Sparkles } from 'lucide-react';

const steps = [
  {
    icon: Target,
    title: 'Enter Your Words',
    description: 'Input the words or concepts you want to create an acronym from.'
  },
  {
    icon: KeySquare,
    title: 'Choose Style',
    description: 'Select from professional, creative, or industry-specific styles.'
  },
  {
    icon: Palette,
    title: 'Generate Options',
    description: 'Our AI creates multiple acronym suggestions based on your input.'
  },
  {
    icon: Sparkles,
    title: 'Pick Your Favorite',
    description: 'Choose the perfect acronym for your needs.'
  }
];

export default function AcronymHowItWorks() {
  return (
    <section className="py-20 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          How Our Acronym Generator Works
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-1/2 w-full h-0.5 bg-blue-200"></div>
              )}
              <div className="relative text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4">
                  <step.icon className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}